import { Steps as ArkSteps } from '@ark-ui/react';

import type { Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type StepsRootProps = ArkSteps.RootProps & {
	size?: Scale3;
};

function StepsRoot({ className, size = '2', ...props }: StepsRootProps) {
	return <ArkSteps.Root className={cn('pt-steps', className)} data-size={size} {...props} />;
}

function StepsRootProvider(props: ArkSteps.RootProviderProps) {
	return <ArkSteps.RootProvider {...props} />;
}

function StepsList({ className, ...props }: ArkSteps.ListProps) {
	return <ArkSteps.List className={cn('pt-steps-list', className)} {...props} />;
}

function StepsItem({ className, ...props }: ArkSteps.ItemProps) {
	return <ArkSteps.Item className={cn('pt-steps-item', className)} {...props} />;
}

function StepsTrigger({ className, ...props }: ArkSteps.TriggerProps) {
	return <ArkSteps.Trigger className={cn('pt-steps-trigger', className)} {...props} />;
}

function StepsIndicator({ className, ...props }: ArkSteps.IndicatorProps) {
	return <ArkSteps.Indicator className={cn('pt-steps-indicator', className)} {...props} />;
}

function StepsSeparator({ className, ...props }: ArkSteps.SeparatorProps) {
	return <ArkSteps.Separator className={cn('pt-steps-separator', className)} {...props} />;
}

function StepsContent({ className, ...props }: ArkSteps.ContentProps) {
	return <ArkSteps.Content className={cn('pt-steps-content', className)} {...props} />;
}

function StepsCompletedContent({ className, ...props }: ArkSteps.CompletedContentProps) {
	return <ArkSteps.CompletedContent className={cn('pt-steps-content', className)} {...props} />;
}

function StepsNextTrigger({ className, ...props }: ArkSteps.NextTriggerProps) {
	return <ArkSteps.NextTrigger className={cn('pt-steps-nav-trigger', className)} {...props} />;
}

function StepsPrevTrigger({ className, ...props }: ArkSteps.PrevTriggerProps) {
	return <ArkSteps.PrevTrigger className={cn('pt-steps-nav-trigger', className)} {...props} />;
}

function StepsProgress({ className, ...props }: ArkSteps.ProgressProps) {
	return <ArkSteps.Progress className={cn('pt-steps-progress', className)} {...props} />;
}

const Steps = {
	Root: StepsRoot,
	RootProvider: StepsRootProvider,
	List: StepsList,
	Item: StepsItem,
	Trigger: StepsTrigger,
	Indicator: StepsIndicator,
	Separator: StepsSeparator,
	Content: StepsContent,
	CompletedContent: StepsCompletedContent,
	NextTrigger: StepsNextTrigger,
	PrevTrigger: StepsPrevTrigger,
	Progress: StepsProgress,
	Context: ArkSteps.Context,
	ItemContext: ArkSteps.ItemContext
};

export { Steps, type StepsRootProps };
